import React from 'react'
import useAuth from '../hooks/useAuth';

function Inactive() {
    const { auth } = useAuth();
    const subscriptionState = auth?.account?.VideoBoostClient?.subscriptionState;
    return (
        <div className='card shadow mx-auto w-50 mt-5'>
            <div className='card-body'>
                <h3 className='mb-0 text-center'>
                    Your account state is <span className='badge rounded-pill text-bg-warning'>{subscriptionState}</span>
                </h3>
            </div>
        </div>
    )
}

export default Inactive